import { render, staticRenderFns } from "./KButton.vue?vue&type=template&id=a24ef83a&scoped=true&"
import script from "./KButton.vue?vue&type=script&lang=js&"
export * from "./KButton.vue?vue&type=script&lang=js&"
import style0 from "./KButton.vue?vue&type=style&index=0&id=a24ef83a&prod&scoped=true&lang=scss&"
import style1 from "./KButton.vue?vue&type=style&index=1&id=a24ef83a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24ef83a",
  null
  
)

export default component.exports